__turbopack_context__.v({
  "error-msg": "table-module-scss-module__GKtp8q__error-msg",
  "errorIcon": "table-module-scss-module__GKtp8q__errorIcon",
  "hint": "table-module-scss-module__GKtp8q__hint",
  "table": "table-module-scss-module__GKtp8q__table",
  "tableBody": "table-module-scss-module__GKtp8q__tableBody",
  "tableCaption": "table-module-scss-module__GKtp8q__tableCaption",
  "tableCell": "table-module-scss-module__GKtp8q__tableCell",
  "tableFooter": "table-module-scss-module__GKtp8q__tableFooter",
  "tableHead": "table-module-scss-module__GKtp8q__tableHead",
  "tableHeader": "table-module-scss-module__GKtp8q__tableHeader",
  "tableRow": "table-module-scss-module__GKtp8q__tableRow",
  "tableWrapper": "table-module-scss-module__GKtp8q__tableWrapper",
});
